import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { createTabScreen } from 'src/navigation/primaryNav/createTabScreen';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/DebugSettings')));
export const debugNavEntry = {
    id: 'debug',
    prefix: 'Debug_',
    to: { screen: 'Debug_Settings', params: {} },
    label: ({ translate }) => translate('Debug'),
    renderIcon: (color, size) => (React.createElement(FeatherIcon, { name: "settings", color: color, size: size })),
    isVisible: ({ isDev }) => isDev,
    placements: ['tab', 'sidebar-main'],
    renderTabRoutes(ctx) {
        return (React.createElement(RootTab.Group, null, createTabScreen(debugNavEntry, ctx, 'Debug_Settings', Home)));
    },
};
export function renderDebugTabRoutes(ctx) {
    return debugNavEntry.renderTabRoutes(ctx);
}
